<template>
	<div class='inform-box'>
        <v-card class="h-full">
			<div class="search-box">
				<div class="sub-title" :class="$vuetify.theme.dark ? 'sub-title-d': 'sub-title-l'">
					<img src="@/assets/img/border.png" alt="">
					<span>{{$t('inform.title')}}</span>
				</div>

				<div class="box">
					<v-row class="px-2 ma-0">
						<v-col cols="12" md="2">
							<v-select
								v-model="filters.state"
								dense
								:items="itemsArr"
								item-value="key"
								item-text="value"
								:label="$t('inform.state.title')"
								outlined
								clearable
								hide-details="auto"
								:menu-props="{ bottom: true, offsetY: true }">
							</v-select>
						</v-col>
						<v-col cols="12" md="3">
							<v-text-field
								v-model="filters.title"
								:label="$t('inform.filtersTitle')"
								outlined
								dense
								hide-details="auto"
								required
							></v-text-field>
						</v-col>
						<v-col cols="12" md="3">
							<v-text-field
								v-model="filters.content"
								:label="$t('inform.filtersContent')"
								outlined
								dense
								hide-details="auto"
								required
							></v-text-field>
						</v-col>
						<v-col cols="12" md="3">
							<v-btn color="primary" @click="handleSearch" height="40">
								{{$t('btn.search')}}
							</v-btn>
							<v-btn style="margin-left: 8px" outlined @click="handleReset" height="40">
								{{$t('btn.reset')}}
							</v-btn>
						</v-col>
					</v-row>
				</div>

				<div class="table-box">
					<div class="mb-2" v-if="informData.length > 0">
						<v-btn color="primary" @click="readFun" small style="font-size:15px;">
							<v-icon size="17" class="read_icon">{{readIcon}}</v-icon>
							{{$t('btn.read')}}
						</v-btn>
					</div>
					<v-data-table
						fixed-header
						class="table-style"
						dense
						size="small"
						:show-select="informData.length >= 1 ? true : false"
						:loading="spinning"
						v-model="selectedRows"
						:loading-text="$t('btn.loading')"
						:headers="columns"
						:items="informData"
						:style="{'height': $vuetify.breakpoint.mdAndDown ? 'auto' : informData.length >= 1 ? 'calc(100vh - 350px)': 'auto'}"
						no-data-text=""
						:server-items-length="totalUserListTable"
						:footer-props="{'items-per-page-options':[10, 20, 50, 100],'items-per-page-text': $t('pagination.perPage'),'page-text': `{0}-{1} ${this.$t('pagination.aggregate')} {2}`}"
						:options.sync="options"
						:hide-default-footer="informData.length < 1"
						:locale="lang"
					>
						<template #[`item.title`]="{item}">
							<a
								@click="showView(item)"
								style="color: #5066e0; cursor: pointer;"
								:title="item.title">
								{{item.title}}
							</a>
						</template>
						<template #[`item.content`]="{item}">
								<span :title="item.content">{{item.content}}</span>
						</template>
						<template v-slot:item.publishTime="{ item }">
							{{ formatDate(item.publishTime) }}
						</template>
						<template #[`item.stateStr`]="{item}">
							<v-chip
								small
								:color="item.state == 0 ? 'error' : 'primary'"
								:class="item.state == 0 ? 'error' : 'primary'"
								class="font-weight-semibold text-capitalize"
							>
								{{ item.state == 0 ? $t('inform.state.value1') : $t('inform.state.value2') }}
							</v-chip>
						</template>
					</v-data-table>
					<div v-if="informData.length < 1" class="text-center">
						<img src="@/assets/img/null.png" alt="">
						<div style="color: #999;">{{$t('adhibition.noData')}}</div>
					</div>
				</div>
			</div>
        </v-card>
		<VDetails v-if="detailsVisible" :visible="detailsVisible" :infoData="infoData" @handleCancel="detailsCancel" @getDatass="getDatass" @input="v=>{this.detailsVisible=v}"></VDetails>

    	<del-dialog :dialogDelete="dialogDelete" :dialogTitle="dialogTitle" @deleteItemConfirm="deleteItemConfirm" @close="dialogDelete=false"></del-dialog>
	</div>
</template>

<script>
import { noticeList, noticeDetail, noticeRead } from "@/api/index";
import moment from 'moment';
import VDetails from './details' // 详情
import store from '@/store'
import { mdiBookCheckOutline } from '@mdi/js';

export default {
	data() {
		return {
			informData: [],
			columns: [],
			filters: {},
			spinning: false,
			detailsVisible: false,
			infoData: {},
            lang:"",
			readIcon:mdiBookCheckOutline,
			itemsArr: [
				{ key: "", value: this.$t('inform.state.value0') },
				{ key: "0", value: this.$t('inform.state.value1') },
				{ key: "1", value: this.$t('inform.state.value2') },
			],
			totalUserListTable: 0,
			options: {
				sortBy: ['id'],
				sortDesc: [true],
        page:1,
        itemsPerPage:20
			},
			selectedRows: [],
			dialogDelete: false,
			dialogTitle: this.$t('inform.confirm')
		};
	},
	components: { VDetails },
	created() {
		this.getData(this.getParams(1, 20))
        this.lang = this.$i18n.locale
		this.columns = [
		{
			text: this.$t('inform.columns.title'),
			value: 'title',
			align: "center",
			ellipsis: true,
			sortable: false,
		},
		{
			text: this.$t('inform.columns.publishTime'),
			value: 'publishTime',
			align: "center",
			ellipsis: true,
			sortable: false,
		},
		{
			text: this.$t('inform.columns.stateStr'),
			value: 'stateStr',
			align: "center",
			ellipsis: true,
			sortable: false,
		},
		{
			text: this.$t('inform.columns.content'),
			value: 'content',
			align: "center",
			ellipsis: true,
			sortable: false,
		},
		{
			text: this.$t('inform.columns.managerName'),
			value: 'managerName',
			align: "center",
			ellipsis: true,
			sortable: false,
		},
		];
	},
	watch: {
		options(val) {
			this.getData(this.getParams())
		}
	},

	methods: {
		moment,
		getData(params) {
			this.spinning = true
			noticeList(params).then(res=> {
				this.spinning = false
				if(res.code == 200) {
					this.informData = res.data.list
					this.totalUserListTable = res.data.total
				}else{
					store.dispatch('snackbar/openSnackbar',{
						snackbarText: res.message,
						colorType: 'error'
					})
				}
			})
		},
		getDatass(){
			this.getData(this.getParams(1, 20))
		},
		formatDate(value) {
            return moment(value * 1000).format('YYYY-MM-DD HH:mm:ss')
        },
		handleReset() {
			this.filters = {}
			this.options.page = 1
			this.options.itemsPerPage = 20
			this.getData(this.getParams(1, 20))
		},
		handleSearch() {
			this.selectedRows = []
			this.getData(this.getParams())
		},
		getParams(pageNum, pageSize) {
			if(!pageNum && !pageSize){
				this.selectedRows = []
			}
			let params = {
				"pageNum": pageNum ? pageNum : this.options.page,
				"pageSize": pageSize ? pageSize : this.options.itemsPerPage,
				"content": this.filters.content,
				"title": this.filters.title,
				"state": this.filters.state,
			}
			return params
		},
		showView(val) {
			val.stateStr = this.$t('inform.read');
			this.infoData = val
			this.detailsVisible = true
		},
		detailsCancel() {
			this.detailsVisible = false
			this.getData(this.getParams())
		},
		readFun() {
			if (this.selectedRows < 1) {
				store.dispatch('snackbar/openSnackbar',{
					snackbarText: this.$t('inform.warn'),
					colorType: 'warn'
				})
				return;
			}

			this.dialogDelete = true
		},
		deleteItemConfirm() {
			let ids = []
			this.selectedRows.map(item=> {
				return ids.push(item.id)
			})
			noticeRead({
				ids: ids
			}).then(res=> {
				if(res.code == 200) {
					this.getData(this.getParams())
					store.dispatch('snackbar/openSnackbar',{
						snackbarText: res.message,
						colorType: 'success'
					})
					this.selectedRows = []
					this.dialogDelete = false
				} else {
					store.dispatch('snackbar/openSnackbar',{
						snackbarText: res.message,
						colorType: 'error'
					})
				}
			})
		}
	},
	mounted(){
		this.$root.eventHub.$on('reloadInformList', ()=>{
			this.getData(this.getParams())
		} )

	},
	beforeDestroy () {
		this.$root.eventHub.$off('reloadInformList')
	},
}
</script>

<style lang='scss' scoped>
.search-box {
//   background: #FFFFFF;
  box-shadow: 0px 0px 46px 0px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 0px 0px 20px;
  height: 100%;
//   margin-bottom: 23px;
  .sub-title {
        font-size: 18px;
        font-weight: 600;
        padding: 8px 0 8px 30px;
        display: flex;
        align-items: center;
        width: 100%;
        border-radius: 6px 6px 0 0;
        margin-bottom: 30px;
        span {
            margin-left: 10px;
        }
    }
    .sub-title-l {
      background: #dce0f9;
      color: #333;
    }
    .sub-title-d {
      border-bottom: 1px solid #f0f0f0;
    }
  .title {
    padding-bottom: 30px;
  }
  .box {
    display: flex;
    .s-list {
      margin-right: 20px;
      display: flex;
      align-items: center;
      .label {
        width: 100px;
        text-align: right;
      }
      .select-flex {
        width: 200px;
      }
    }
  }
}
.table-box ::v-deep {
//   background: #FFFFFF;
//   box-shadow: 0px 0px 46px 0px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 20px 20px 30px 20px;
//   margin-top: 30px;
  .btn-box {
    margin-bottom: 8px;
  }
  .ant-table-small {
    border: 0;
  }
  .ant-table-small > .ant-table-content .ant-table-header {
    background: rgb(220 224 249 / 25%);
    color: #333;
    font-size: 14px;
  }
  .ant-table-tbody .ant-table-row:nth-child(2n) {
    background: #fbfbfb;
  }
  .ant-table-small > .ant-table-content .ant-table-row:last-child td {
    border-bottom: 1px solid #e8e8e8;
  }
  .ant-table-footer {
    position: absolute;
    padding: 16px 5px;
    background: none;
    border: 0;
    margin-top: 1px;
  }
}
::v-deep {
    .v-data-table__wrapper{
        // height: calc(100vh - 390px);
		height: 100%;
        overflow: auto;
    }
}
.inform-box{
	height: 100%;
}
@media (min-width: 850px) {
	::v-deep {
		.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td{
			max-width: 30px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
}
@media screen and (min-width: 320px) and (max-width: 480px) {
	::v-deep{
		.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td :nth-child(1){
			.v-data-table__mobile-row{
				justify-content: flex-start;
			}
			text-align: left;
		}
		.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td{
			max-width: 338px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			.v-data-table__mobile-row__cell{
				width: 95%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				position: relative;
    			left: -4px;
			}
		}
	}
}
.read_icon{
	margin-top: 2px;
	margin-right: 3px;
}
</style>
